import { SupportedDemandType } from 'enums/SupportedDemandType';

export function useCheckPricingExists(
  supportedDemandTypes: SupportedDemandType[]
) {
  const checkPricingExists = () => {
    return supportedDemandTypes.some((item) => {
      return (
        item === SupportedDemandType.AVAILABILITY ||
        item === SupportedDemandType.IMMEDIATE_RESERVATION ||
        item === SupportedDemandType.RESERVATION
      );
    });
  };

  return {
    checkPricingExists,
  };
}
